import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
	ArrowRight,
	Coffee,
	Croissant,
	Star,
	MapPin,
	Clock,
	ChevronLeft,
	ChevronRight,
} from "lucide-react";
import { Helmet } from "react-helmet-async";
import { Button } from "../components/ui/button";
import { ProductCard } from "../components/products/ProductCard";
import { supabase } from "../lib/supabase";
import api from "../lib/api";

const getHeroSlideUrl = (filename) => {
	const { data } = supabase.storage
		.from("images")
		.getPublicUrl(`home-slides/${filename}`);
	return data.publicUrl;
};

const testimonials = [
	{
		id: 1,
		name: "Nolwenn Bizouarn",
		text: "C'est juste un endroit parfait : calme malgré la proximité de l'Ifage, personnel adorable et compétent, carte variée en salé comme en sucré, décoration choisie avec goût et playlists excellentes. C'est devenu mon café favori.",
		rating: 5,
	},
	{
		id: 2,
		name: "Michael Corbat (“Mich”)",
		text: "Petit café self-service situé dans l’IFAGE, avec un personnel sympathique. Très peu de bruit et aucune attente.",
		rating: 5,
	},
	{
		id: 3,
		name: "Turbo Express",
		text: "Les mots ne peuvent pas décrire parfaitement cet endroit. Il y a une vraie chaleur humaine et un savoir-faire culinaire remarquable.",
		rating: 5,
	},
	{
		id: 4,
		name: "J Dauneau",
		text: "Un excellent moment dans un cadre un peu club. Le personnel est toujours souriant et disponible.",
		rating: 5,
	},
	{
		id: 5,
		name: "Eadon Alun",
		text: "Repas sur place très agréable, peu de bruit, aucune attente et endroit adapté pour discuter facilement.",
		rating: 5,
	},
	{
		id: 6,
		name: "Rb Ml",
		text: "Cuisine, service et ambiance au top.",
		rating: 5,
	},
	{
		id: 7,
		name: "Marie",
		text: "J’adore : personnel sympa, thé au coquelicot gourmand délicieux, ambiance topissime. J’y viens aussi travailler, c’est mon QG préféré.",
		rating: 5,
	},
	{
		id: 8,
		name: "Евгений Форкаш",
		text: "Courez vite ici pour manger des biscuits et boire du café. Endroit agréable, peu bruyant et service rapide.",
		rating: 5,
	},
	{
		id: 9,
		name: "Patrick Bellair",
		text: "Comme à la maison : un lieu chaleureux et convivial. Les propriétaires accueillent comme des amis et la nourriture faite maison est délicieuse.",
		rating: 5,
	},
	{
		id: 10,
		name: "Santoria Liano",
		text: "Café très savoureux et personnel sympathique. Très satisfait, je reviendrai certainement.",
		rating: 5,
	},
	{
		id: 11,
		name: "Микаел Чальян",
		text: "Avis 5 étoiles laissé sur Google.",
		rating: 5,
	},
	{
		id: 12,
		name: "Anastasia Billy",
		text: "Joli café avec de bons gâteaux, une serveuse très sympathique et une musique délicieuse.",
		rating: 5,
	},
	{
		id: 13,
		name: "Marianna Zangrillo",
		text: "Personnel vraiment sympathique et serviable, bons sandwichs, limonades et thés faits maison.",
		rating: 5,
	},
	{
		id: 14,
		name: "soutien edices",
		text: "Avis 5 étoiles laissé sur Google.",
		rating: 5,
	},
	{
		id: 15,
		name: "Junior Alexandre",
		text: "À Legers Coffee, l’arôme est riche, la saveur parfaitement équilibrée et chaque tasse apporte une vraie sensation d’authenticité. Le service est rapide, soigné et l’équipe toujours chaleureuse.",
		rating: 5,
	},
	{
		id: 16,
		name: "Venus Leger",
		text: "Avis 5 étoiles laissé sur Google.",
		rating: 5,
	},
	{
		id: 17,
		name: "AURORE GAUDICHAU",
		text: "Superbe lieu très bien décoré, avec un personnel sympathique et accueillant.",
		rating: 5,
	},
	{
		id: 18,
		name: "Natacha Pambou",
		text: "Endroit agréable et cosy pour discuter avec des amis ou étudier. ",
		rating: 5,
	},
	{
		id: 19,
		name: "Cristian Catre",
		text: "Avis 5 étoiles laissé sur Google.",
		rating: 5,
	},
	{
		id: 20,
		name: "Andrea Atropina",
		text: "Super ambiance, service au top, café délicieux ainsi que les plats proposés.",
		rating: 5,
	},
	{
		id: 21,
		name: "Van PBirk",
		text: "Franchement, la nourriture était excellente et le service impeccable. Je recommande vivement.",
		rating: 5,
	},
	{
		id: 22,
		name: "Iancu Buda",
		text: "Excellent café, service impeccable et cadre agréable. Que demander de plus ?",
		rating: 5,
	},
	{
		id: 23,
		name: "Voguis Srl",
		text: "Service haut de gamme, meilleur endroit à Genève.",
		rating: 5,
	},
	{
		id: 24,
		name: "Pit Bot",
		text: "Jolie découverte, endroit décontracté chic. Merci pour l’accueil, je reviendrai.",
		rating: 5,
	},
	{
		id: 25,
		name: "Stephane Khahamyan",
		text: "Cuisine, service et ambiance irréprochables.",
		rating: 5,
	},
	{
		id: 26,
		name: "Tonic Valley",
		text: "Mon QG de travail quand je viens à l’IFAGE. Chargeurs à induction, prises à disposition, service autonome pratique et collaborateurs adorables. Comme à la maison, en mieux.",
		rating: 5,
	},
	{
		id: 27,
		name: "Swiss Kiwi",
		text: "Un immense merci à toute l’équipe de Légers. L’apéro, les finger foods et la présentation étaient incroyables, tout était délicieux et préparé avec soin.",
		rating: 5,
	},
	{
		id: 28,
		name: "Mario",
		text: "En tant qu’étudiante, j’adore commander un café chez Legers Coffee et m’installer près de la fenêtre. Il y a des bornes de recharge, l’ambiance est parfaite et le personnel très accueillant.",
		rating: 5,
	},
	{
		id: 29,
		name: "Kateryna Petrychenko",
		text: "Délicieux à souhait : tout est frais et d’excellente qualité. L’endroit est magnifique, spacieux, parfait pour travailler sur ordinateur portable, avec un accueil exceptionnel.",
		rating: 5,
	},
	{
		id: 30,
		name: "Gerald Muriel (Temiatwork)",
		text: "Très bien situé avec un bon cappuccino.",
		rating: 5,
	},
	{
		id: 31,
		name: "Neroshi Gagamoto",
		text: "Le meilleur endroit à Genève pour les nomades numériques. Je le recommande vivement à ceux qui travaillent avec un ordinateur portable.",
		rating: 5,
	},
	{
		id: 32,
		name: "Camille",
		text: "Avis 5 étoiles laissé sur Google.",
		rating: 5,
	},
	{
		id: 33,
		name: "yves donati",
		text: "Très bon cappuccino servi par une personne très sympathique et charmante.",
		rating: 5,
	},
	{
		id: 34,
		name: "Vince Fasciani",
		text: "Chose rare : un café excellent, mais surtout un service encore mieux qu’à la maison. J’y passerais tous les jours.",
		rating: 5,
	},
	{
		id: 35,
		name: "Marco",
		text: "Très bon café, service impeccable.",
		rating: 5,
	},
];

// --- Full-bleed : contenu court, punchy, image = star du visuel ---
const fullBleedSlides = [
	{
		id: 1,
		eyebrow: "Nouveauté de saison",
		title: "La carte d'automne est là",
		description:
			"Latte à la citrouille, chocolat noisette et créations chaudes pour vos matinées.",
		imageUrl: getHeroSlideUrl("IMG_1965.jpeg"),
		imageAlt: "Latte à la citrouille avec cannelle et anis étoilé",
		buttonLabel: "Voir la carte",
		buttonLink: "/menu",
		isExternal: false,
	},
	{
		id: 2,
		eyebrow: "Café de spécialité",
		title: "L'excellence dans chaque tasse",
		description:
			"Grains sélectionnés, torréfaction locale, extraction maîtrisée.",
		imageUrl: getHeroSlideUrl("IMG_1969.jpeg"),
		imageAlt: "Grains de café fraîchement torréfiés",
		buttonLabel: "Découvrir nos cafés",
		buttonLink: "/menu",
		isExternal: false,
	},
	{
		id: 3,
		eyebrow: "Boissons signature",
		title: "Nos créations exclusives",
		description:
			"Iced latte vanille, cappuccino léger, matcha maison — nos boissons emblématiques.",
		imageUrl: getHeroSlideUrl("IMG_1973.jpeg"),
		imageAlt: "Assortiment de boissons signature du coffee shop",
		buttonLabel: "Commander",
		buttonLink: "/menu",
		isExternal: false,
	},
	{
		id: 4,
		eyebrow: "Brunch du samedi",
		title: "Un moment généreux à partager",
		description:
			"Œufs brouillés, avocado toast, granola maison, jus pressés minute.",
		imageUrl: getHeroSlideUrl("IMG_1972.jpeg"),
		imageAlt: "Table dressée pour un brunch au coffee shop",
		buttonLabel: "Réserver une table",
		buttonLink: "/reservation",
		isExternal: false,
	},
	{
		id: 5,
		eyebrow: "Événements privés",
		title: "Notre espace, vos occasions",
		description:
			"Anniversaires, réunions d'équipe, lancements — un cadre à votre image.",
		imageUrl: getHeroSlideUrl("IMG_1966.jpeg"),
		imageAlt: "Salle de coffee shop chaleureuse préparée pour un événement",
		buttonLabel: "Nous contacter",
		buttonLink: "/contact",
		isExternal: false,
	},
];

// --- Slider normal (split image/texte) : contenu détaillé, storytelling ---
const sliderSlides = [
	{
		id: 1,
		eyebrow: "Fidélité",
		title: "Chaque 10ᵉ café offert",
		description:
			"Rejoignez notre programme de fidélité et savourez votre café favori en cadeau tous les dix passages. Simple, transparent, généreux — parce que revenir chez nous devrait toujours être une récompense.",
		imageUrl: getHeroSlideUrl("IMG_1967.jpeg"),
		imageAlt: "Tasse de café et carte de fidélité posées sur une table en bois",
		buttonLabel: "Créer un compte",
		buttonLink: "/inscription",
		isExternal: false,
	},
	{
		id: 2,
		eyebrow: "Pâtisseries maison",
		title: "Des créations artisanales chaque jour",
		description:
			"Nos pâtissiers imaginent une sélection renouvelée régulièrement — croissants beurrés au feuilletage doré, cookies fondants au chocolat noir, tartes de saison aux fruits frais. À savourer sur place avec un café ou à emporter pour prolonger le plaisir.",
		imageUrl: getHeroSlideUrl("IMG_1970.jpeg"),
		imageAlt: "Vitrine de pâtisseries artisanales",
		buttonLabel: "Voir les pâtisseries",
		buttonLink: "/menu",
		isExternal: false,
	},
	{
		id: 3,
		eyebrow: "Espace de travail",
		title: "Votre QG pour travailler à Genève",
		description:
			"Wi-Fi rapide, nombreuses prises électriques, chargeurs à induction discrets et ambiance calme. Que ce soit pour une session studieuse concentrée ou un rendez-vous informel autour d'un café, notre coffee shop est pensé pour accompagner vos journées de travail.",
		imageUrl: getHeroSlideUrl("IMG_1971.jpeg"),
		imageAlt: "Espace de travail chaleureux dans le coffee shop",
		buttonLabel: "Nous rendre visite",
		buttonLink: "/a-propos",
		isExternal: false,
	},
	{
		id: 4,
		eyebrow: "Notre équipe",
		title: "Une passion partagée",
		description:
			"Baristas passionnés, sourires sincères, conseils personnalisés. Derrière chaque tasse servie, il y a une équipe qui met tout son cœur à rendre votre visite mémorable — envie de découvrir une nouvelle origine, comprendre un procédé d'extraction, ou simplement discuter café, on est là pour ça.",
		imageUrl: getHeroSlideUrl("IMG_1975.jpeg"),
		imageAlt: "Barista préparant un café avec attention",
		buttonLabel: "Notre histoire",
		buttonLink: "/a-propos",
		isExternal: false,
	},
	{
		id: 5,
		eyebrow: "À emporter",
		title: "Commandez et récupérez sans attendre",
		description:
			"Passez votre commande directement depuis notre menu en ligne et venez la chercher au comptoir sans faire la queue. Parfait pour les matins pressés avant le bureau, les pauses déjeuner minutées ou simplement pour éviter d'attendre.",
		imageUrl: getHeroSlideUrl("IMG_1976.jpeg"),
		imageAlt: "Café à emporter dans un gobelet du coffee shop",
		buttonLabel: "Commander en ligne",
		buttonLink: "/menu",
		isExternal: false,
	},
	{
		id: 6,
		eyebrow: "Suivez-nous",
		title: "Restez connectés à l'univers Léger's",
		description:
			"Nouveautés éphémères, coulisses de la torréfaction, événements exclusifs, créations imaginées avec nos partenaires locaux — retrouvez toute l'actualité du coffee shop sur nos réseaux sociaux et ne manquez aucune surprise.",
		imageUrl: getHeroSlideUrl("IMG_1977.jpeg"),
		imageAlt: "Ambiance conviviale au coffee shop",
		buttonLabel: "Nous contacter",
		buttonLink: "/contact",
		isExternal: false,
	},
];

const heroSlides = [
	{
		id: 1,
		image: getHeroSlideUrl("IMG_1977.jpeg"),
		imageAlt: "Intérieur du coffee shop Léger's Coffee à Genève",
		eyebrow: "Coffee Shop • Genève",
		title: (
			<>
				L'art du café,
				<br />
				<span className="text-latte-gold">simplement léger</span>
			</>
		),
		description:
			"Découvrez notre sélection de cafés de spécialité et nos pâtisseries artisanales au cœur de Genève.",
		buttonLabel: "Voir le Menu",
		buttonLink: "/menu",
	},
	{
		id: 2,
		image: getHeroSlideUrl("IMG_1976.jpeg"),
		imageAlt: "Café de spécialité chez Léger's Coffee",
		eyebrow: "Café de spécialité",
		title: (
			<>
				L'excellence
				<br />
				<span className="text-latte-gold">dans chaque tasse</span>
			</>
		),
		description:
			"Des cafés soigneusement sélectionnés et préparés avec passion.",
		buttonLabel: "Découvrir nos cafés",
		buttonLink: "/menu",
	},
	{
		id: 3,
		image: getHeroSlideUrl("IMG_1966.jpeg"),
		imageAlt: "Boisson signature Léger's Coffee",
		eyebrow: "Boissons signature",
		title: (
			<>
				Nos créations
				<br />
				<span className="text-latte-gold">exclusives</span>
			</>
		),
		description:
			"Découvrez nos boissons signatures imaginées pour vous surprendre.",
		buttonLabel: "Commander",
		buttonLink: "/menu",
	},
	{
		id: 4,
		image: getHeroSlideUrl("IMG_1975.jpeg"),
		imageAlt: "Brunch chez Léger's Coffee",
		eyebrow: "Brunch du samedi",
		title: (
			<>
				Un moment
				<br />
				<span className="text-latte-gold">généreux à partager</span>
			</>
		),
		description: "Profitez d'un brunch gourmand dans une ambiance chaleureuse.",
		buttonLabel: "Réserver une table",
		buttonLink: "/reservation",
	},
];

export default function HomePage() {
	const [isUnlocked, setIsUnlocked] = useState(() => {
		return localStorage.getItem("website_access_granted") === "true";
	});

	const [passwordInput, setPasswordInput] = useState("");
	const [passwordError, setPasswordError] = useState("");
	const [isAuthenticating, setIsAuthenticating] = useState(false);
	const [authMessage, setAuthMessage] = useState("");

	const [featuredProducts, setFeaturedProducts] = useState([]);
	const [testimonialPage, setTestimonialPage] = useState(0);

	const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	const [productsLoading, setProductsLoading] = useState(true);

	const [fullBleedPage, setFullBleedPage] = useState(0);
	const [heroPage, setHeroPage] = useState(0);
	const [sliderPage, setSliderPage] = useState(0);

	useEffect(() => {
		const interval = setInterval(() => {
			setHeroPage((prev) => (prev + 1) % heroSlides.length);
		}, 6000);

		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (fullBleedSlides.length <= 1) return;
		const interval = setInterval(() => {
			setFullBleedPage((prev) => (prev + 1) % fullBleedSlides.length);
		}, 6000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		if (sliderSlides.length <= 1) return;
		const interval = setInterval(() => {
			setSliderPage((prev) => (prev + 1) % sliderSlides.length);
		}, 7000);
		return () => clearInterval(interval);
	}, []);

	useEffect(() => {
		localStorage.setItem("website_access_granted", "true");
		setIsUnlocked(true);
	}, []);

	const handleUnlock = async (e) => {
		e.preventDefault();

		if (isAuthenticating) return;

		if (!passwordInput.trim()) {
			setPasswordError("Veuillez entrer un mot de passe");
			return;
		}

		setPasswordError("");
		setIsAuthenticating(true);
		setAuthMessage("Authentification en cours...");

		try {
			await wait(900);

			const { data, error } = await supabase.rpc("verify_website_password", {
				input_password: passwordInput,
			});

			if (error) throw error;

			if (!data) {
				setIsAuthenticating(false);
				setAuthMessage("");
				setPasswordInput("");
				setPasswordError("Mot de passe incorrect");
				return;
			}

			setAuthMessage("Mot de passe vérifié");
			await wait(900);

			setAuthMessage("Accès autorisé");
			await wait(900);

			localStorage.setItem("website_access_granted", "true");
			setIsUnlocked(true);
			setPasswordInput("");
			setAuthMessage("");
			setIsAuthenticating(false);
		} catch (err) {
			console.error("Erreur authentification :", err);
			setIsAuthenticating(false);
			setAuthMessage("");
			setPasswordInput("");
			setPasswordError("Une erreur est survenue pendant l'authentification");
		}
	};

	useEffect(() => {
		if (!isUnlocked) return;

		const fetchFeaturedProducts = async () => {
			try {
				setProductsLoading(true);

				const CACHE_TTL = 5 * 60 * 1000;
				const cached = sessionStorage.getItem("featured_products");
				const cachedAt = sessionStorage.getItem("featured_products_at");
				const isExpired =
					!cachedAt || Date.now() - Number(cachedAt) > CACHE_TTL;

				if (cached && !isExpired) {
					setFeaturedProducts(JSON.parse(cached));
					setProductsLoading(false);
					return;
				}

				const data = await api.getFeaturedProducts();
				setFeaturedProducts(data || []);

				sessionStorage.setItem("featured_products", JSON.stringify(data || []));
				sessionStorage.setItem("featured_products_at", String(Date.now()));
			} catch (error) {
				console.error("Erreur API produits:", error);
				setFeaturedProducts([]);
			} finally {
				setProductsLoading(false);
			}
		};

		fetchFeaturedProducts();
	}, [isUnlocked]);

	const pageTitle = "Léger's Coffee | Coffee Shop à Genève";
	const pageDescription =
		"Découvrez Léger's Coffee à Genève : café de spécialité, viennoiseries artisanales, pâtisseries maison et boissons de saison dans un coffee shop chaleureux au cœur de la ville.";
	const canonicalUrl = "https://legerscoffee.fr/";
	const ogImage =
		"https://images.unsplash.com/photo-1671934944865-2a84561cdc1c?w=1920&q=80";

	const structuredDataBusiness = {
		"@context": "https://schema.org",
		"@type": "CafeOrCoffeeShop",
		name: "Léger's Coffee",
		image: [ogImage],
		url: canonicalUrl,
		description: pageDescription,
		telephone: "+41 22 123 45 67",
		address: {
			"@type": "PostalAddress",
			streetAddress: "Pl. des Augustins 19",
			postalCode: "1205",
			addressLocality: "Genève",
			addressCountry: "CH",
		},
		geo: {
			"@type": "GeoCoordinates",
			latitude: 46.19107968464716,
			longitude: 6.1415484766377615,
		},
		servesCuisine: ["Café", "Coffee Shop", "Viennoiseries", "Pâtisseries"],
		priceRange: "$$",
		openingHoursSpecification: [
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
				opens: "07:00",
				closes: "20:30",
			},
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: "Friday",
				opens: "07:00",
				closes: "17:00",
			},
			{
				"@type": "OpeningHoursSpecification",
				dayOfWeek: "Saturday",
				opens: "07:00",
				closes: "14:00",
			},
		],
		aggregateRating: {
			"@type": "AggregateRating",
			ratingValue: "5",
			reviewCount: "35",
		},
		review: testimonials.map((testimonial) => ({
			"@type": "Review",
			author: {
				"@type": "Person",
				name: testimonial.name,
			},
			reviewBody: testimonial.text,
			reviewRating: {
				"@type": "Rating",
				ratingValue: testimonial.rating,
				bestRating: "5",
			},
		})),
	};

	const structuredDataWebsite = {
		"@context": "https://schema.org",
		"@type": "WebSite",
		name: "Léger's Coffee",
		url: canonicalUrl,
		inLanguage: "fr-CH",
	};

	const visibleTestimonials = 3;
	const totalSlides = Math.max(
		testimonials.length - visibleTestimonials + 1,
		1,
	);

	useEffect(() => {
		if (totalSlides <= 1) return;

		const interval = setInterval(() => {
			setTestimonialPage((prev) => (prev + 1) % totalSlides);
		}, 5000);

		return () => clearInterval(interval);
	}, [totalSlides]);

	return (
		<>
			<Helmet>
				<html lang="fr" />
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
				<meta name="robots" content="index, follow" />
				<link rel="canonical" href={canonicalUrl} />

				<meta property="og:type" content="website" />
				<meta property="og:site_name" content="Léger's Coffee" />
				<meta property="og:locale" content="fr_CH" />
				<meta property="og:title" content={pageTitle} />
				<meta property="og:description" content={pageDescription} />
				<meta property="og:url" content={canonicalUrl} />
				<meta property="og:image" content={ogImage} />

				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:title" content={pageTitle} />
				<meta name="twitter:description" content={pageDescription} />
				<meta name="twitter:image" content={ogImage} />

				<script type="application/ld+json">
					{JSON.stringify(structuredDataBusiness)}
				</script>
				<script type="application/ld+json">
					{JSON.stringify(structuredDataWebsite)}
				</script>
			</Helmet>

			{!isUnlocked && (
				<div
					className="fixed inset-0 z-[9999] bg-black/80 backdrop-blur-md flex items-center justify-center px-6"
					role="dialog"
					aria-modal="true"
					aria-labelledby="password-modal-title"
				>
					<div className="w-full max-w-md bg-warm-alabaster border border-border-subtle shadow-2xl p-8">
						<div className="text-center mb-6">
							<h2
								id="password-modal-title"
								className="font-serif text-2xl text-espresso font-semibold mb-3"
							>
								Site en cours de construction
							</h2>

							<p className="text-soft-charcoal-secondary leading-relaxed">
								Le site est actuellement en cours de développement.
							</p>

							<p className="text-soft-charcoal-secondary mt-2">
								Son accès est public, mais son contenu est temporairement
								restreint.
							</p>
						</div>

						<form onSubmit={handleUnlock} className="space-y-4">
							<input
								type="password"
								value={passwordInput}
								onChange={(e) => {
									setPasswordInput(e.target.value);
									if (passwordError) setPasswordError("");
								}}
								placeholder="Accès temporaire"
								disabled={isAuthenticating}
								autoFocus
								className="w-full border border-border-subtle bg-white px-4 py-3 text-espresso outline-none focus:border-latte-gold disabled:opacity-60"
							/>

							{passwordError && (
								<p className="text-sm text-red-600 text-center">
									{passwordError}
								</p>
							)}

							{authMessage && (
								<div className="text-center py-2">
									<p className="text-sm font-medium text-espresso animate-pulse">
										{authMessage}
									</p>
								</div>
							)}

							<Button
								type="submit"
								className="w-full btn-primary"
								disabled={isAuthenticating}
							>
								{isAuthenticating ? "Vérification..." : "Accéder au site"}
							</Button>
						</form>
					</div>
				</div>
			)}

			<main
				data-testid="home-page"
				className="min-h-screen"
				aria-hidden={!isUnlocked}
			>
				{/* Hero Section - Slider */}
				<section className="relative h-screen min-h-[700px] flex items-center overflow-hidden">
					{/* Background Slider */}
					<div className="absolute inset-0 z-0 overflow-hidden">
						<div
							className="flex h-full transition-transform duration-1000 ease-in-out"
							style={{
								transform: `translateX(-${heroPage * 100}%)`,
							}}
						>
							{heroSlides.map((slide, index) => (
								<div
									key={slide.id}
									className="relative w-full h-full flex-shrink-0"
								>
									<img
										src={slide.image}
										alt={slide.imageAlt}
										className="w-full h-full object-cover"
										loading={index === 0 ? "eager" : "lazy"}
									/>

									{/* Overlay */}
									<div className="absolute inset-0 bg-gradient-to-r from-espresso/80 via-espresso/40 to-transparent" />
								</div>
							))}
						</div>
					</div>

					{/* Content */}
					<div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full">
						<div className="max-w-2xl">
							{/* Eyebrow */}
							<span
								key={`eyebrow-${heroPage}`}
								className="inline-block text-latte-gold text-sm uppercase tracking-widest font-medium mb-6 opacity-0 animate-fade-in"
							>
								{heroSlides[heroPage].eyebrow}
							</span>

							{/* Title */}
							<h1
								key={`title-${heroPage}`}
								className="font-serif text-4xl sm:text-5xl lg:text-6xl text-warm-alabaster font-semibold leading-tight mb-6 opacity-0 animate-fade-in animate-stagger-1"
							>
								{heroSlides[heroPage].title}
							</h1>

							{/* Description */}
							<p
								key={`description-${heroPage}`}
								className="text-warm-alabaster/80 text-lg mb-8 max-w-lg leading-relaxed opacity-0 animate-fade-in animate-stagger-2"
							>
								{heroSlides[heroPage].description}
							</p>

							{/* Buttons */}
							<div
								key={`buttons-${heroPage}`}
								className="flex flex-col sm:flex-row gap-4 opacity-0 animate-fade-in animate-stagger-3"
							>
								{/* Primary Button */}
								<Button
									asChild
									className="btn-primary bg-latte-gold hover:bg-latte-gold-secondary"
									data-testid="hero-menu-btn"
								>
									<Link to={heroSlides[heroPage].buttonLink}>
										{heroSlides[heroPage].buttonLabel}
										<ArrowRight className="ml-2 w-4 h-4" />
									</Link>
								</Button>

								{/* Secondary Button */}
								<Button
									asChild
									className="btn-secondary border-warm-alabaster text-warm-alabaster hover:bg-warm-alabaster hover:text-espresso"
									data-testid="hero-order-btn"
								>
									<Link to="/menu">Commander Maintenant</Link>
								</Button>
							</div>
						</div>
					</div>

					{/* Previous Button */}
					{heroSlides.length > 1 && (
						<button
							type="button"
							onClick={() =>
								setHeroPage(
									(prev) => (prev - 1 + heroSlides.length) % heroSlides.length,
								)
							}
							className="absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-warm-alabaster/10 backdrop-blur-md border border-warm-alabaster/20 flex items-center justify-center text-warm-alabaster hover:bg-latte-gold hover:border-latte-gold transition-all duration-300"
							aria-label="Slide précédente"
						>
							<ChevronLeft className="w-5 h-5" />
						</button>
					)}

					{/* Next Button */}
					{heroSlides.length > 1 && (
						<button
							type="button"
							onClick={() =>
								setHeroPage((prev) => (prev + 1) % heroSlides.length)
							}
							className="absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-warm-alabaster/10 backdrop-blur-md border border-warm-alabaster/20 flex items-center justify-center text-warm-alabaster hover:bg-latte-gold hover:border-latte-gold transition-all duration-300"
							aria-label="Slide suivante"
						>
							<ChevronRight className="w-5 h-5" />
						</button>
					)}

					{/* Slider Dots */}
					{heroSlides.length > 1 && (
						<div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
							{heroSlides.map((slide, index) => (
								<button
									key={slide.id}
									type="button"
									onClick={() => setHeroPage(index)}
									className={`h-2 rounded-full transition-all duration-500 ${
										index === heroPage
											? "bg-latte-gold w-10"
											: "bg-warm-alabaster/40 hover:bg-warm-alabaster/70 w-2"
									}`}
									aria-label={`Afficher la slide ${index + 1}`}
								/>
							))}
						</div>
					)}

					{/* Scroll Indicator */}
					<div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
						<div className="w-6 h-10 border-2 border-warm-alabaster/30 rounded-full flex justify-center pt-2">
							<div className="w-1 h-2 bg-warm-alabaster/50 rounded-full" />
						</div>
					</div>
				</section>

				{/* Slider Section */}
				<section className="section-padding bg-warm-alabaster">
					<div className="max-w-7xl mx-auto">
						<div className="relative">
							<div className="overflow-hidden">
								<div
									className="flex transition-transform duration-700 ease-out"
									style={{
										transform: `translateX(-${sliderPage * 100}%)`,
									}}
								>
									{sliderSlides.map((slide) => (
										<div
											key={slide.id}
											className="w-full flex-shrink-0"
											aria-hidden={sliderSlides[sliderPage].id !== slide.id}
										>
											<div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
												<div className="relative aspect-[4/3] lg:aspect-[5/4] overflow-hidden">
													<img
														src={slide.imageUrl}
														alt={slide.imageAlt}
														className="w-full h-full object-cover"
														loading="lazy"
													/>
												</div>

												<div>
													<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
														{slide.eyebrow}
													</span>

													<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold mb-6">
														{slide.title}
													</h2>

													<p className="text-soft-charcoal-secondary leading-relaxed mb-8">
														{slide.description}
													</p>

													<Button asChild className="btn-primary">
														{slide.isExternal ? (
															<a
																href={slide.buttonLink}
																target="_blank"
																rel="noopener noreferrer"
															>
																{slide.buttonLabel}
																<ArrowRight className="ml-2 w-4 h-4" />
															</a>
														) : (
															<Link to={slide.buttonLink}>
																{slide.buttonLabel}
																<ArrowRight className="ml-2 w-4 h-4" />
															</Link>
														)}
													</Button>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>

							{/* Flèches de navigation */}
							{sliderSlides.length > 1 && (
								<>
									<button
										type="button"
										onClick={() =>
											setSliderPage(
												(prev) =>
													(prev - 1 + sliderSlides.length) %
													sliderSlides.length,
											)
										}
										className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 lg:-translate-x-6 w-11 h-11 rounded-full bg-warm-alabaster border border-border-subtle shadow-md flex items-center justify-center text-espresso hover:bg-latte-gold hover:text-warm-alabaster hover:border-latte-gold transition-colors duration-300"
										aria-label="Slide précédente"
									>
										<ChevronLeft className="w-5 h-5" />
									</button>

									<button
										type="button"
										onClick={() =>
											setSliderPage((prev) => (prev + 1) % sliderSlides.length)
										}
										className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 lg:translate-x-6 w-11 h-11 rounded-full bg-warm-alabaster border border-border-subtle shadow-md flex items-center justify-center text-espresso hover:bg-latte-gold hover:text-warm-alabaster hover:border-latte-gold transition-colors duration-300"
										aria-label="Slide suivante"
									>
										<ChevronRight className="w-5 h-5" />
									</button>
								</>
							)}
						</div>

						{/* Puces de navigation */}
						{sliderSlides.length > 1 && (
							<div className="flex justify-center gap-2 mt-10">
								{sliderSlides.map((slide, index) => (
									<button
										key={slide.id}
										type="button"
										onClick={() => setSliderPage(index)}
										className={`h-2.5 rounded-full transition-all duration-300 ${
											index === sliderPage
												? "bg-latte-gold w-8"
												: "bg-espresso/20 hover:bg-espresso/40 w-2.5"
										}`}
										aria-label={`Afficher la slide ${index + 1}`}
									/>
								))}
							</div>
						)}
					</div>
				</section>

				{/* Slider Section - Full-bleed */}
				<section className="relative">
					<div className="relative h-[85vh] min-h-[600px] lg:h-[90vh] lg:min-h-[700px] overflow-hidden">
						<div
							className="flex h-full transition-transform duration-1000 ease-out"
							style={{
								transform: `translateX(-${fullBleedPage * 100}%)`,
							}}
						>
							{fullBleedSlides.map((slide) => (
								<div
									key={slide.id}
									className="relative w-full h-full flex-shrink-0"
								>
									{/* Image de fond */}
									<div className="absolute inset-0 z-0">
										<img
											src={slide.imageUrl}
											alt={slide.imageAlt}
											className="w-full h-full object-cover"
											loading={slide.id === 1 ? "eager" : "lazy"}
										/>
										<div className="absolute inset-0 bg-gradient-to-r from-espresso/80 via-espresso/50 to-espresso/20" />
									</div>

									{/* Contenu textuel */}
									<div className="relative z-10 h-full flex items-center">
										<div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
											<div className="max-w-2xl">
												<span className="inline-block text-latte-gold text-sm uppercase tracking-widest font-medium mb-6">
													{slide.eyebrow}
												</span>

												<h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-warm-alabaster font-semibold leading-tight mb-6">
													{slide.title}
												</h2>

												<p className="text-warm-alabaster/80 text-lg mb-8 max-w-lg leading-relaxed">
													{slide.description}
												</p>

												<Button
													asChild
													className="btn-primary bg-latte-gold hover:bg-latte-gold-secondary"
												>
													{slide.isExternal ? (
														<a
															href={slide.buttonLink}
															target="_blank"
															rel="noopener noreferrer"
														>
															{slide.buttonLabel}
															<ArrowRight className="ml-2 w-4 h-4" />
														</a>
													) : (
														<Link to={slide.buttonLink}>
															{slide.buttonLabel}
															<ArrowRight className="ml-2 w-4 h-4" />
														</Link>
													)}
												</Button>
											</div>
										</div>
									</div>
								</div>
							))}
						</div>

						{/* Flèches de navigation */}
						{fullBleedSlides.length > 1 && (
							<>
								<button
									type="button"
									onClick={() =>
										setFullBleedPage(
											(prev) =>
												(prev - 1 + fullBleedSlides.length) %
												fullBleedSlides.length,
										)
									}
									className="absolute left-4 lg:left-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-warm-alabaster/10 backdrop-blur-md border border-warm-alabaster/20 flex items-center justify-center text-warm-alabaster hover:bg-latte-gold hover:border-latte-gold transition-all duration-300"
									aria-label="Slide précédente"
								>
									<ChevronLeft className="w-5 h-5" />
								</button>

								<button
									type="button"
									onClick={() =>
										setFullBleedPage(
											(prev) => (prev + 1) % fullBleedSlides.length,
										)
									}
									className="absolute right-4 lg:right-8 top-1/2 -translate-y-1/2 z-20 w-12 h-12 rounded-full bg-warm-alabaster/10 backdrop-blur-md border border-warm-alabaster/20 flex items-center justify-center text-warm-alabaster hover:bg-latte-gold hover:border-latte-gold transition-all duration-300"
									aria-label="Slide suivante"
								>
									<ChevronRight className="w-5 h-5" />
								</button>
							</>
						)}

						{/* Puces de navigation */}
						{fullBleedSlides.length > 1 && (
							<div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex gap-2">
								{fullBleedSlides.map((slide, index) => (
									<button
										key={slide.id}
										type="button"
										onClick={() => setFullBleedPage(index)}
										className={`h-2 rounded-full transition-all duration-500 ${
											index === fullBleedPage
												? "bg-latte-gold w-10"
												: "bg-warm-alabaster/40 hover:bg-warm-alabaster/70 w-2"
										}`}
										aria-label={`Afficher la slide ${index + 1}`}
									/>
								))}
							</div>
						)}
					</div>
				</section>

				{/* Presentation Section */}
				<section className="section-padding bg-warm-alabaster">
					<div className="max-w-7xl mx-auto">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
							<div className="order-2 lg:order-1">
								<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
									Notre Histoire
								</span>
								<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold mb-6">
									Un café d'exception,
									<br />
									une passion authentique
								</h2>
								<p className="text-soft-charcoal-secondary leading-relaxed mb-6">
									Niché au cœur de Genève, Léger's Coffee est né d'une passion
									pour le café de qualité et l'art de l'hospitalité. Chaque
									tasse est préparée avec soin, utilisant des grains
									soigneusement sélectionnés et torréfiés localement.
								</p>
								<p className="text-soft-charcoal-secondary leading-relaxed mb-8">
									Notre équipe de baristas passionnés vous accueille dans un
									espace chaleureux où tradition et modernité se rencontrent.
								</p>
								<Button
									asChild
									className="btn-secondary"
									data-testid="discover-story-btn"
								>
									<Link to="/a-propos">
										Découvrir Notre Histoire
										<ArrowRight className="ml-2 w-4 h-4" />
									</Link>
								</Button>
							</div>
							<div className="order-1 lg:order-2">
								<div className="relative">
									<img
										src="https://esugmretwvpafowskyck.supabase.co/storage/v1/object/public/images/WhatsApp%20Image%202026-09-19%20at%2010.12.42%20(11).jpeg"
										alt="Barista préparant un latte art chez Léger's Coffee"
										className="w-full aspect-[4/5] object-cover"
									/>
									<div className="absolute -bottom-6 -left-6 bg-latte-gold text-warm-alabaster p-6 hidden lg:block">
										<p className="font-serif text-3xl font-semibold">10+</p>
										<p className="text-sm uppercase tracking-wider">
											Années d'expérience
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				{/* Specialties Section */}
				<section className="section-padding bg-warm-secondary">
					<div className="max-w-7xl mx-auto">
						<div className="text-center mb-16">
							<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
								Nos Spécialités
							</span>
							<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold">
								L'excellence dans chaque détail
							</h2>
						</div>

						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
							{[
								{
									icon: Coffee,
									title: "Cafés de Spécialité",
									desc: "Grains arabica torréfiés localement",
								},
								{
									icon: Croissant,
									title: "Viennoiseries",
									desc: "Fraîches chaque matin",
								},
								{
									icon: Star,
									title: "Pâtisseries",
									desc: "Créations artisanales",
								},
								{
									icon: Coffee,
									title: "Boissons de Saison",
									desc: "Créations limitées",
								},
							].map((item, index) => (
								<div
									key={index}
									className="bg-warm-alabaster p-8 border border-border-subtle hover:border-latte-gold transition-colors duration-300 text-center"
								>
									<div className="w-14 h-14 mx-auto mb-6 rounded-full bg-warm-secondary flex items-center justify-center">
										<item.icon className="w-6 h-6 text-latte-gold" />
									</div>
									<h3 className="font-serif text-lg font-semibold text-espresso mb-2">
										{item.title}
									</h3>
									<p className="text-soft-charcoal-secondary text-sm">
										{item.desc}
									</p>
								</div>
							))}
						</div>
					</div>
				</section>

				{/* Featured Products */}
				<section className="section-padding bg-warm-alabaster">
					<div className="max-w-7xl mx-auto">
						<div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12">
							<div>
								<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
									Nos Favoris
								</span>
								<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold">
									Produits Populaires
								</h2>
							</div>
							<Button
								asChild
								className="btn-secondary mt-6 lg:mt-0"
								data-testid="view-all-products-btn"
							>
								<Link to="/menu">
									Voir Tout le Menu
									<ArrowRight className="ml-2 w-4 h-4" />
								</Link>
							</Button>
						</div>

						<div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-12">
							{productsLoading
								? Array.from({ length: 4 }).map((_, i) => (
										<div key={i} className="animate-pulse">
											<div className="aspect-[4/5] bg-warm-secondary mb-4" />
											<div className="h-3 bg-warm-secondary rounded mb-2 w-1/3" />
											<div className="h-4 bg-warm-secondary rounded mb-2 w-3/4" />
											<div className="h-3 bg-warm-secondary rounded w-1/2" />
											<div className="h-5 bg-warm-secondary rounded mt-3 w-1/4" />
										</div>
									))
								: featuredProducts.map((product, index) => (
										<ProductCard
											key={product.id}
											product={product}
											index={index}
										/>
									))}
						</div>
					</div>
				</section>

				{/* Testimonials */}
				<section className="section-padding bg-espresso text-warm-alabaster">
					<div className="max-w-7xl mx-auto">
						<div className="text-center mb-16">
							<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
								Témoignages
							</span>
							<h2 className="font-serif text-3xl lg:text-4xl font-semibold">
								Ce que disent nos clients
							</h2>
						</div>

						<div className="overflow-hidden">
							<div
								className="flex transition-transform duration-700 ease-out"
								style={{
									transform: `translateX(-${testimonialPage * (100 / visibleTestimonials)}%)`,
								}}
							>
								{testimonials.map((testimonial) => (
									<div
										key={testimonial.id}
										className="w-full md:w-1/3 flex-shrink-0 px-4"
									>
										<div className="bg-espresso-hover/30 p-8 border border-warm-alabaster/10 h-full flex flex-col">
											<div className="flex mb-4">
												{[...Array(testimonial.rating)].map((_, i) => (
													<Star
														key={i}
														className="w-4 h-4 fill-latte-gold text-latte-gold"
													/>
												))}
											</div>

											<p className="text-warm-alabaster/80 leading-relaxed mb-6 flex-1">
												"{testimonial.text}"
											</p>

											<p className="font-serif font-semibold text-latte-gold">
												{testimonial.name}
											</p>
										</div>
									</div>
								))}
							</div>
						</div>

						{totalSlides > 1 && (
							<div className="flex justify-center gap-2 mt-10 flex-wrap">
								{Array.from({ length: totalSlides }).map((_, index) => (
									<button
										key={index}
										type="button"
										onClick={() => setTestimonialPage(index)}
										className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${
											index === testimonialPage
												? "bg-latte-gold scale-110"
												: "bg-warm-alabaster/20 hover:bg-warm-alabaster/40"
										}`}
										aria-label={`Afficher l’avis ${index + 1}`}
									/>
								))}
							</div>
						)}
					</div>
				</section>

				{/* CTA Section */}
				<section className="section-padding bg-warm-secondary">
					<div className="max-w-4xl mx-auto text-center">
						<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
							Commandez en Ligne
						</span>
						<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold mb-6">
							Vos cafés préférés, livrés chez vous
						</h2>
						<p className="text-soft-charcoal-secondary mb-8 max-w-2xl mx-auto">
							Commandez en ligne et récupérez votre commande directement au
							comptoir, ou profitez de notre service de livraison à Genève.
						</p>
						<Button
							asChild
							className="btn-primary"
							data-testid="order-online-btn"
						>
							<Link to="/menu">
								Commander Maintenant
								<ArrowRight className="ml-2 w-4 h-4" />
							</Link>
						</Button>
					</div>
				</section>

				{/* Visit Section */}
				<section className="section-padding bg-warm-alabaster">
					<div className="max-w-7xl mx-auto">
						<div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
							<div>
								<span className="text-latte-gold text-sm uppercase tracking-widest font-medium mb-4 block">
									Nous Rendre Visite
								</span>
								<h2 className="font-serif text-3xl lg:text-4xl text-espresso font-semibold mb-6">
									Retrouvez-nous à Genève
								</h2>

								<div className="space-y-6 mb-8">
									<div className="flex items-start space-x-4">
										<MapPin className="w-6 h-6 text-latte-gold flex-shrink-0 mt-1" />
										<div>
											<h4 className="font-semibold text-espresso mb-1">
												Adresse
											</h4>
											<p className="text-soft-charcoal-secondary">
												Pl. des Augustins 19
												<br />
												1205 Genève, Suisse
											</p>
										</div>
									</div>
									<div className="flex items-start space-x-4">
										<Clock className="w-6 h-6 text-latte-gold flex-shrink-0 mt-1" />
										<div>
											<h4 className="font-semibold text-espresso mb-1">
												Horaires
											</h4>
											<p className="text-soft-charcoal-secondary">
												Lun - Jeu : 07:00 – 20:30
												<br />
												Vendredi : 07:00 – 17:00
												<br />
												Samedi : 07:00 – 14:00
												<br />
												Dimanche : Fermé
											</p>
										</div>
									</div>
								</div>

								<Button
									asChild
									className="btn-secondary"
									data-testid="visit-us-btn"
								>
									<a
										href="https://maps.google.com/?q=Place+des+Augustins+19+1205+Genève+Suisse"
										target="_blank"
										rel="noopener noreferrer"
									>
										Obtenir l'Itinéraire
										<ArrowRight className="ml-2 w-4 h-4" />
									</a>
								</Button>
							</div>

							<div className="aspect-square bg-warm-secondary">
								<iframe
									src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2761.9738179693322!2d6.1415484766377615!3d46.19107968464716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478c7b82f8a384d5%3A0xf93e62705740f243!2sL%C3%A9ger&#39;s%20Coffee!5e0!3m2!1sfr!2sfr!4v1773058704116!5m2!1sfr!2sfr"
									width="100%"
									height="100%"
									style={{ border: 0 }}
									allowFullScreen=""
									loading="lazy"
									referrerPolicy="no-referrer-when-downgrade"
									title="Léger's Coffee Location"
								/>
							</div>
						</div>
					</div>
				</section>
			</main>
			{/* <div className="fixed bottom-4 left-4 z-[9999] max-w-xs rounded-2xl border border-white/10 bg-espresso/90 backdrop-blur-md shadow-2xl px-4 py-3 text-warm-alabaster">
        <div className="flex items-start gap-3">
          <div className="mt-1 flex h-3 w-3">
            <span className="absolute inline-flex h-3 w-3 rounded-full bg-latte-gold opacity-75 animate-ping"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-latte-gold"></span>
          </div>

          <div>
            <p className="text-sm font-semibold text-latte-gold">
              Site en amélioration
            </p>
            <p className="mt-1 text-xs leading-relaxed text-warm-alabaster/80">
              Nous peaufinons actuellement l’expérience pour vous offrir une version encore plus élégante et fluide.
            </p>
          </div>
        </div>
      </div> */}
			{/* <div className="fixed bottom-4 right-4 z-[9999] max-w-sm rounded-2xl border border-white/10 bg-espresso/90 backdrop-blur-xl shadow-2xl px-4 py-3 text-warm-alabaster">
        <div className="flex items-start gap-3">
          <div className="relative mt-1 flex h-3 w-3 flex-shrink-0">
            <span className="absolute inline-flex h-3 w-3 rounded-full bg-latte-gold opacity-75 animate-ping"></span>
            <span className="relative inline-flex h-3 w-3 rounded-full bg-latte-gold"></span>
          </div>

          <div>
            <div className="flex items-center gap-2">
              <p className="text-sm font-semibold text-latte-gold">
                Paiements en paramétrage
              </p>
              <span className="rounded-full border border-latte-gold/30 bg-latte-gold/10 px-2 py-0.5 text-[10px] uppercase tracking-wider text-latte-gold">
                Bientôt disponible
              </span>
            </div>

            <p className="mt-1 text-xs leading-relaxed text-warm-alabaster/80">
              Le système de paiement est actuellement en cours de configuration et n’est pas encore fonctionnel.
            </p>
          </div>
        </div>
      </div> */}
		</>
	);
}
